import * as Actions from '../actions';

const initialState = {
    incorrectPasswordEntered: false,
    passwordChanged: false
}

const passwordreset = function (state = initialState, action) {
    switch ( action.type )
    {
        case(Actions.CHECK_PASSWORD):
        {
            return {
                ...state,
                incorrectPasswordEntered: action.payload
            }
        }
        default:
        {
            return state
        }
        case(Actions.CHANGE_PASSWORD):
        {
            return {
                ...state,
                passwordChanged: action.payload,
                passwordValid: true
            }
        }
        case(Actions.RESET_PASSWORD_CHANGED):
        {
            return {
                ...state,
                passwordChanged: false,
                incorrectPasswordEntered: false
            }
        }
    }

};

export default passwordreset;


// WEBPACK FOOTER //
// src/auth/store/reducers/passwordchange.reducer.js